module.exports = __webpack_public_path__ + "img/loyalty-hub-logo.dbea2e14.png";